import {
  APPLICATION_REQUEST,
  APPLICATION_SUCCESS,
  APPLICATION_FAILURE,
  APPLICATION_CREATE,
  COUPON_PROVIDER,
  COUPON_PROVIDER_REQUEST,
  COUPON_PROVIDER_SUCCESS,
  COUPON_PROVIDER_FAILURE,
  COUPON_PROVIDER_BOOKFAIR,
  COUPON_PROVIDER_BOOKFAIR_REQUEST,
  COUPON_PROVIDER_BOOKFAIR_SUCCESS,
  COUPON_PROVIDER_BOOKFAIR_FAILURE,
  PREPARE_TRIAL,
  PROVIDE_TRIAL,
  PREPARE_BOOKFAIR_TRIAL,
  PROVIDE_BOOKFAIR_TRIAL
} from '@/store/types'

import axios from '@/store/axios'

const state = {
  isCouponApplicationLoading: false,
  isCouponProviderLoading: false,
  preparedTrialCode: null,
  preparedBookfairTrialCode: null
}
const getters = {
  getCouponApplicationLoading: (state) => state.isCouponApplicationLoading,
  getPreparedTrialCode: (state) => state.preparedTrialCode,
  getPreparedBookfairTrialCode: (state) => state.preparedBookfairTrialCode
}
const actions = {
  [APPLICATION_CREATE]: ({ commit }, { memberCode, bookCode }) => {
    commit(APPLICATION_REQUEST)
    return new Promise((resolve, reject) => {
      axios
        .post('/customer/deskcopy/apply', {
          deskCopyApplication: { memberCode: memberCode, bookCode: bookCode }
        })
        .then((res) => {
          commit(APPLICATION_SUCCESS)
          resolve(res)
        })
        .catch((err) => {
          commit(APPLICATION_FAILURE, err)
          reject(err)
        })
    })
  },
  [COUPON_PROVIDER_BOOKFAIR]: ({ commit }, { bookCode }) => {
    commit(COUPON_PROVIDER_BOOKFAIR_REQUEST)
    return new Promise((resolve, reject) => {
      axios
        .post('/coupon/provider/bookfair', {
          bookCode: bookCode
        })
        .then((res) => {
          commit(COUPON_PROVIDER_BOOKFAIR_SUCCESS)
          commit(PROVIDE_BOOKFAIR_TRIAL)
          resolve(res)
        })
        .catch((err) => {
          commit(COUPON_PROVIDER_BOOKFAIR_FAILURE)
          commit(PROVIDE_BOOKFAIR_TRIAL)
          reject(err)
        })
    })
  },
  [COUPON_PROVIDER]: ({ commit }, { code }) => {
    commit(COUPON_PROVIDER_REQUEST)
    return new Promise((resolve, reject) => {
      axios
        .post('/coupon/provider/trial', {
          code: code
        })
        .then((res) => {
          commit(COUPON_PROVIDER_SUCCESS)
          commit(PROVIDE_TRIAL)
          resolve(res)
        })
        .catch((err) => {
          commit(COUPON_PROVIDER_FAILURE)
          commit(PROVIDE_TRIAL)
          reject(err)
        })
    })
  }
}
const mutations = {
  [APPLICATION_REQUEST]: (state) => {
    state.isCouponApplicationLoading = true
  },
  [APPLICATION_SUCCESS]: (state) => {
    state.isCouponApplicationLoading = false
  },
  [APPLICATION_FAILURE]: (state, err) => {
    state.isCouponApplicationLoading = false
    state.err = err
  },
  [COUPON_PROVIDER_REQUEST]: (state) => {
    state.isCouponProviderLoading = true
  },
  [COUPON_PROVIDER_SUCCESS]: (state) => {
    state.isCouponProviderLoading = false
  },
  [COUPON_PROVIDER_FAILURE]: (state, err) => {
    state.isCouponProviderLoading = false
    state.err = err
  },
  [COUPON_PROVIDER_BOOKFAIR_REQUEST]: (state) => {
    state.isCouponProviderLoading = true
  },
  [COUPON_PROVIDER_BOOKFAIR_SUCCESS]: (state) => {
    state.isCouponProviderLoading = false
  },
  [COUPON_PROVIDER_BOOKFAIR_FAILURE]: (state, err) => {
    state.isCouponProviderLoading = false
    state.err = err
  },
  [PREPARE_TRIAL]: (state, code) => {
    state.preparedTrialCode = code
    localStorage.setItem('trialCode', code)
  },
  [PROVIDE_TRIAL]: (state) => {
    state.preparedTrialCode = null
    localStorage.removeItem('trialCode')
  },
  [PREPARE_BOOKFAIR_TRIAL]: (state, code) => {
    state.preparedBookfairTrialCode = code
    localStorage.setItem('bookfairtrialCode', code)
  },
  [PROVIDE_BOOKFAIR_TRIAL]: (state) => {
    state.preparedBookfairTrialCode = null
    localStorage.removeItem('bookfairtrialCode')
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
